<div class="item-box"
     [ngClass]="{'collapsable': showStatusChangeReason}"
>
    <ng-content select=".ellipsis-to-drag"></ng-content>
    <div class="container">

        <div class="main-section">
            <div class="card-block">
                <div class="project-number">
                    {{tile.jobNumber}}
                </div>
                <div class="project-name">
                    {{tile.jobName}}
                </div>
            </div>

            <div class="labels card-block">
                <div class="base-labels">
                    <div class="label status-indicator" *ngIf="tile.jobPaymentStatusId"
                         style.background-color="#{{tile.jobPaymentStatusColor}}">
                    </div>
                    <div class="label type-indicator"
                         style.background-color="#{{tile.typeColor}}">
                        {{tile.typeShortCode}}
                    </div>
                    <div class="label" *ngIf="tile.jobTypeShortTitle && tile.jobTypeShortTitle !== 'Lam'"
                         style.background-color="#{{tile.jobTypeColor}}">{{tile.jobTypeShortTitle}}
                    </div>
                </div>
                <div class="right-labels">
                    <i class="pi pi-exclamation-triangle" style="font-size: 125%" *ngIf="!tile.jobSalesListReady" pTooltip="Sales list is not completed" tooltipPosition="top"></i>
                    <!--            <mat-icon *ngIf="!tile.jobSalesListReady">warning_amber</mat-icon>-->
                </div>
            </div>

            <div class="icons-block card-block">
                <div class="date-icon icon-block" *ngIf="tile.endDate" pTooltip="Activity due" tooltipPosition="bottom"
                     [ngClass]="{'past-due': tile.endDate <= today && !tile.ready}">
                    <i class="pi pi-clock" style="font-size: 125%"></i>

                    <div class="date">
                        {{tile.endDate | date: 'MMM d' }}
                    </div>
                </div>
                <div class="date-icon icon-block" *ngIf="tile.jobDueDate" pTooltip="Job due" tooltipPosition="bottom"
                     [ngClass]="{'past-due': tile.jobDueDate <= today && !tile.ready}">
                    <i class="pi pi-calendar" style="font-size: 125%"></i>

                    <div class="date">
                        {{tile.jobDueDate | date: 'MMM d' }}
                    </div>
                </div>
            </div>
<!--            <div class="users-block card-block" *ngIf="showUser && tile.userId">-->
<!--                <div class="user-icon">-->
<!--                    <div class="word-avatar">-->
<!--                        <div class="short-name">-->
<!--                            {{tile.userShortCode}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="right-section">
<!--            <div>Created on {{tile.createdDate | date: 'MMM d' }} </div>-->
            <div *ngIf="tile.assignDate && tile.userId">Assigned on {{tile.assignDate | date: 'MMM d' }} to {{tile.userName}}</div>
            <div>{{tile.jobComplexityShortTitle}} complexity, takes {{tile.duration / 3600 | number: '1.0-0'}} hours </div>
            <div *ngIf="tile.ready">Completed: {{tile.toggleDate | date: 'MMM d' }}</div>
        </div>
    </div>
    <div class="collapsable-block" *ngIf="showStatusChangeReason"
         [ngClass]="{'editing': tile.isEditing}"
         (click)="startEditing($event)">
        <div *ngIf="!tile.isEditing"
             class="status-reason-display">
            <span>{{tile.statusChangeReason ? tile.statusChangeReason : 'Hold Reason'}}</span>
        </div>
        <form #editForm="ngForm" *ngIf="tile.isEditing" cdkDragDisabled>
            <textarea type="text" class="status-reason-input" maxlength="250"
                   [(ngModel)]="tile.statusChangeReason"
                   (blur)="stopEditing()"
                   (keydown.escape)="cancelEditing()"
                   (click)="$event.stopPropagation()"
                   (mousedown)="$event.stopPropagation()"
                   placeholder="Hold Reason"
                   #reasonInput
                   name="statusChangeReason">
            </textarea>
        </form>
    </div>
</div>